module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page-main"
  }, [_c('header-comp'), _vm._v(" "), _c('nav-bar'), _vm._v(" "), _c('div', {
    staticClass: "my-3 my-md-5"
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('footer-comp')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-70ca3e78!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/DashView.vue
// module id = 578
// module chunks = 2